module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-07.fffeb3a9.jpeg";